import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  margin: 40px auto;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 200px auto 25px;
  margin-top: 20px;
`;

const TestDataRenderer = (props) => {
  return <Wrapper {...props}>{props.children}</Wrapper>;
};

export default TestDataRenderer;
